module.exports = __webpack_public_path__ + "static/media/student-callout.95ad1403.png";